module.exports = __webpack_public_path__ + "img/project-zx.cccc81af.jpg";